<template>
  <div class="recyle-process">
    <div class="container clearfix">
      <div class="logo-wrap">
        <router-link to="/">
          <img class="icon-logo" src="//s1.huishoubao.com/static/pc/1001/img/logo.png">
        </router-link>
      </div>
      <ul class="grid-list fr">
        <li class="grid-item" :class="{'is-active': $route.meta.recycleIndex >= 1}">
          <span class="grid-item__label">1</span>
          <span class="grid-item__text">机况评估</span>
          <ProcessDots class="process-dots" :length="3"></ProcessDots>
        </li>
        <li class="grid-item" :class="{'is-active': $route.meta.recycleIndex >= 2}">
          <span class="grid-item__label">2</span>
          <span class="grid-item__text">获得报价</span>
          <ProcessDots class="process-dots" :length="3"></ProcessDots>
        </li>
        <li class="grid-item" :class="{'is-active': $route.meta.recycleIndex >= 3}">
          <span class="grid-item__label">3</span>
          <span class="grid-item__text">提交订单</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ProcessDots from '../process-dots';
export default {
  components: {
    ProcessDots
  }
};
</script>

<style lang="postcss" scoped>
@import 'config.css';
.recyle-process {
  background-color: #fff;
}
.logo-wrap {
  float: left;
  .icon-logo {
    width: 225px;
  }
}

.grid-item {
  float: left;
  line-height: 26px;
  margin-top: 28px;
  &__label {
    float: left;
    display: inline-block;
    width: 26px;
    height: 26px;
    font-size: 12px;
    line-height: 24px;
    margin: 0 8px;
    color: #b2b6b8;
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 50%;
  }
  &__text {
    float: left;
    color: #909090;
  }
  &.is-active {
    .grid-item__label {
      color: #fff;
      border: none;
      background: rgb(250, 190, 0);
    }
    .grid-item__text {
      color: rgb(250, 190, 0);
    }
  }
}

.process-dots {
  float: left;
  margin-top: 11px;
  margin-left: 10px;
  /deep/ .process-dot {
    position: relative;
    width: 3px;
    height: 3px;
    border-radius: 3px;
    margin-left: 10px;
    background-color: #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/components/logo-process/index.vue